import Button from '@amzn/awsui-components-core/button';
import Input from '@amzn/awsui-components-core/input';
import React from 'react';
import { StarGridText } from 'src/components/star-grid/hooks/useStarGridText';
import { PNL_ROW_HEIGHTS } from 'src/components/star-grid/utils/pnlStatementGrid';

export interface GridToolbarState {
  readonly text: StarGridText;
  readonly search: string;
  readonly setSearch: (value: string) => void;
  readonly rowHeight: number;
  readonly setRowHeight: (value: number) => void;
  readonly showFilters: boolean;
  readonly setShowFilters: (value: boolean) => void;
  readonly toggleColumns: () => void;
}
const DENSITY_LABELS = ['compactRows', 'mediumRows', 'standardRows'] as const;

export const ReportGridToolbar: React.FC<{ readonly state: GridToolbarState }> = ({ state }) => (
  <div className="sg-report-grid-toolbar">
    <div className="sg-report-search">
      <Input
        type="search"
        value={state.search}
        placeholder={state.text('searchReport')}
        ariaLabel={state.text('searchReport')}
        onChange={({ detail }) => state.setSearch(detail.value)}
      />
    </div>
    <div className="sg-report-grid-actions" role="group" aria-label={state.text('tableDisplay')}>
      {PNL_ROW_HEIGHTS.map((height, index) => (
        <button
          type="button"
          key={height}
          className="sg-report-density"
          aria-label={state.text(DENSITY_LABELS[index])}
          title={state.text(DENSITY_LABELS[index])}
          aria-pressed={state.rowHeight === height}
          onClick={() => state.setRowHeight(height)}
        >
          <span className={`sg-report-density-lines sg-report-density-${index}`} aria-hidden="true" />
        </button>
      ))}
      <Button variant="icon" iconName="settings" ariaLabel={state.text('columnSettings')} onClick={state.toggleColumns} />
      <Button
        variant="icon"
        iconName="filter"
        ariaLabel={state.text('toggleColumnFilters')}
        onClick={() => state.setShowFilters(!state.showFilters)}
      />
    </div>
  </div>
);
